import { STORE_ID, TYPES } from "./types";
import store from "../../index";

function dispatch(data) {
  data = { ...data, storeId: STORE_ID };
  store.dispatch(data);
}
export function setItems(value) {
  dispatch({
    type: TYPES.SET_ITEMS,
    value,
  });
}
export function setItem(value) {
  dispatch({
    type: TYPES.SET_ITEM,
    value,
  });
}
export function setFeriados(value) {
  dispatch({
    type: TYPES.FERIADOS,
    value,
  });
}
export function pesquisar(value) {
  dispatch({
    type: TYPES.PESQUISA,
    value,
  });
}
export function getAllItems(value) {
  dispatch({
    type: TYPES.GET_ALL_ITENS,
    value,
  });
}
export function setSelectedItems(value) {
  dispatch({
    type: TYPES.SET_SELECTED_ITEMS,
    value,
  });
}
export function setTotals(value) {
  dispatch({
    type: TYPES.TOTALS,
    value,
  });
}
export function setPermitions(value) {
  dispatch({
    type: TYPES.SET_PERMITIONS,
    value,
  });
}

export function copy(value) {
  dispatch({
    type: TYPES.FERIADO_COPY,
    value: { ...value },
  });
}
export function setSeeRegister(value) {
  dispatch({
    type: TYPES.SET_SEE,
    value,
  });
}
export function setInvalid(field) {
  dispatch({
    type: TYPES.INVALID,
    field,
  });
}

export function cleanInvalid(field) {
  dispatch({
    type: TYPES.CLEAN_INVALID,
    field,
  });
}
export function setActiveTab(value) {
  dispatch({
    type: TYPES.SET_ACTIVE_TAB,
    value,
  });
}
export function cleanSearch() {
  dispatch({
    type: TYPES.CLEAN_SEARCH,
  });
}
export function cleanRegister() {
  dispatch({
    type: TYPES.CLEAN_REGISTER,
  });
}
